import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '../ui/ui.module';
import {
    NgbAccordionModule,
    NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {
    MissingTranslationHandler,
    TranslateModule,
} from '@ngx-translate/core';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { NgxMaskPipe } from 'ngx-mask';
import { LottieModule } from 'ngx-lottie';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SummaryComponent } from './summary/summary.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { ProgressBarMobileComponent } from './progress-bar-mobile/progress-bar-mobile.component';
import { ReservationDetailsComponent } from './reservation-details/reservation-details.component';
import { LocationDetailComponent } from './location-detail/location-detail.component';
import { ProtectionLevelComponent } from './protection-level/protection-level.component';
import { TravelUpgradesComponent } from './travel-upgrades/travel-upgrades.component';
import { CarouselComponent } from './carousel/carousel.component';
import { CardLocationComponent } from './card-location/card-location.component';
import { WarrantyComponent } from './warranty/warranty.component';
import { TipsComponent } from './tips/tips.component';
import { ReservationParentComponent } from './reservation-parent/reservation-parent.component';
import { CancelReservationComponent } from './cancel-reservation/cancel-reservation.component';
import { DeliveryStatusComponent } from './delivery-status/delivery-status.component';
import { DeliveryCancelParentComponent } from './delivery-cancel-parent/delivery-cancel-parent.component';
import { HrefSubheaderComponent } from './href-subheader/href-subheader.component';
import { DetailsDataModule } from '@/data/details/details-data.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CancelationDataModule } from '@/data/cancelation/cancelation-data.module';
import { BillingDataComponent } from './billing-data/billing-data.component';
import { PrecheckinProgressComponent } from './precheckin-progress/precheckin-progress.component';
import { OfficialDocumentsComponent } from './official-documents/official-documents.component';
import { ReservationInfoComponent } from './reservation-info/reservation-info.component';
import { CarFeaturesComponent } from './car-features/car-features.component';
import { RentalRequirementsComponent } from './rental-requirements/rental-requirements.component';
import { PrimaryContainerComponent } from './primary-container/primary-container.component';
import { CardActiveReservationComponent } from './card-active-reservation/card-active-reservation.component';
import { EmptyContainerComponent } from './empty-container/empty-container.component';
import { CardGeneralInformationComponent } from './card-general-information/card-general-information.component';
import { CardFlightInformationComponent } from './card-flight-information/card-flight-information.component';
import { PrecheckinLayoutComponent } from './precheckin-layout/precheckin-layout.component';
import { PrecheckinButtonsComponent } from './precheckin-buttons/precheckin-buttons.component';
import { AlertComponent } from './alert/alert.component';
import { CardPromotionComponent } from './card-promotion/card-promotion.component';
import { FeaturedPromotionsComponent } from './featured-promotions/featured-promotions.component';
import { PromotionHeroComponent } from './promotion-hero/promotion-hero.component';
import { PromotionOfferComponent } from './promotion-offer/promotion-offer.component';
import { PromotionReasonsComponent } from './promotion-reasons/promotion-reasons.component';
import { PromotionTermsComponent } from './promotion-terms/promotion-terms.component';
import { FooterComponent } from './footer/footer.component';
import { ApiMissingTranslationHandler } from '@/core/translations/api.missing.translation.handler';
import { CarRentalPolicyComponent } from './car-rental-policy/car-rental-policy.component';
import { BlogCardsComponent } from './blog-cards/blog-cards.component';
import { PopularDestinationsComponent } from './popular-destinations/popular-destinations.component';
import { OfficeSearchComponent } from './office-search/office-search.component';
import { ShowCityOfficeDetailsComponent } from './show-city-office-details/show-city-office-details.component';
import { CardLandingTitleComponent } from './card-landing-title/card-landing-title.component';
import { HbsptformComponent } from './hbsptform/hbsptform.component';
import { StartReservationComponent } from './start-reservation/start-reservation.component';
import { ContainerCompanyPoliciesComponent } from './container-company-policies/container-company-policies.component';
import { SearchReservationComponent } from './search-reservation/search-reservation.component';
import { PickUpOptionsComponent } from './pick-up-options/pick-up-options.component';
import { LocationDetailDestinationComponent } from './location-detail-destination/location-detail-destination.component';
import { CarouselDataModule } from '../../../data/carousel/carousel-data.module';
import { SsrService } from '@/common/services/ssr/ssr.service';
import { CarsCardsComponent } from './cars-cards/cars-cards.component';
import { NewsletterDataModule } from '@/data/newsletter/newsletter.module';
import { MaintenanceStandaloneComponent } from './maintenance-standalone/maintenance-standalone.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { ModalCookiesConsentComponent } from './modal-cookies-consent/modal-cookies-consent.component';
import { CarouselCarsComponent } from './carousel-cars/carousel-cars.component';
import { HbsptformNewComponent } from './hbsptform-new/hbsptform-new.component';
import { UpgradePromotionComponent } from './upgrade-promotion/upgrade-promotion.component';
import { UpgradePromotionSummaryComponent } from './upgrade-promotion-summary/upgrade-promotion-summary.component';
import { HbsptformNewEnComponent } from './hbsptformEn-new/hbsptformEn-new.component';
import { UpgradeCategoryComponent } from './upgrade-category/upgrade-category.component';
import { StandardCareComponent } from './standard-care/standard-care.component';
import { ReservationBannerComponent } from './reservation-banner/reservation-banner.component';
import { PayMethodModalComponent } from './pay-method-modal/pay-method-modal.component';
import { InsuranceInfoModalComponent } from './insurance-info-modal/insurance-info-modal.component';
import { VehicleListComponent } from './vehicle-list/vehicle-list.component';
import { ReviewReserveComponent } from './review-reserve/review-reserve.component';
import { PhoneLadaInputComponent } from './phone-lada-input/phone-lada-input.component';
import { FormEnterprisesComponent } from './form-enterprises/form-enterprises.component';
import { BannerLandingTitleComponent } from './banner-landing-title/banner-landing-title.component';
import { TypPageComponent } from '@/ui/pages/landings/typ/typ.component';
import { SnowEffectComponent } from './snow-effect/snow-effect.component';

export function playerFactory() {
    return import('lottie-web');
}

@NgModule({
    declarations: [
        PhoneLadaInputComponent,
        ProgressBarComponent,
        SummaryComponent,
        PersonalInformationComponent,
        ProgressBarMobileComponent,
        ReservationDetailsComponent,
        LocationDetailComponent,
        ProtectionLevelComponent,
        TravelUpgradesComponent,
        CarouselComponent,
        CarouselCarsComponent,
        CardLocationComponent,
        WarrantyComponent,
        TipsComponent,
        ReservationParentComponent,
        CancelReservationComponent,
        DeliveryStatusComponent,
        DeliveryCancelParentComponent,
        HrefSubheaderComponent,
        BillingDataComponent,
        PrecheckinProgressComponent,
        OfficialDocumentsComponent,
        ReservationInfoComponent,
        CarFeaturesComponent,
        RentalRequirementsComponent,
        PrimaryContainerComponent,
        CardActiveReservationComponent,
        EmptyContainerComponent,
        CardGeneralInformationComponent,
        CardFlightInformationComponent,
        PrecheckinLayoutComponent,
        PrecheckinButtonsComponent,
        AlertComponent,
        CardPromotionComponent,
        FeaturedPromotionsComponent,
        PromotionHeroComponent,
        PromotionOfferComponent,
        PromotionReasonsComponent,
        PromotionTermsComponent,
        FooterComponent,
        CarRentalPolicyComponent,
        BlogCardsComponent,
        PopularDestinationsComponent,
        OfficeSearchComponent,
        ShowCityOfficeDetailsComponent,
        CardLandingTitleComponent,
        HbsptformComponent,
        HbsptformNewComponent,
        HbsptformNewEnComponent,
        StartReservationComponent,
        ContainerCompanyPoliciesComponent,
        SearchReservationComponent,
        PickUpOptionsComponent,
        LocationDetailDestinationComponent,
        CarsCardsComponent,
        MaintenanceStandaloneComponent,
        CookieConsentComponent,
        ModalCookiesConsentComponent,
        UpgradePromotionComponent,
        UpgradePromotionSummaryComponent,
        UpgradeCategoryComponent,
        StandardCareComponent,
        ReservationBannerComponent,
        PayMethodModalComponent,
        InsuranceInfoModalComponent,
        VehicleListComponent,
        ReviewReserveComponent,
        FormEnterprisesComponent,
        BannerLandingTitleComponent,
        TypPageComponent,
        SnowEffectComponent,
        SnowEffectComponent,
    ],
    exports: [
        ProgressBarComponent,
        SummaryComponent,
        PersonalInformationComponent,
        ProgressBarMobileComponent,
        ReservationDetailsComponent,
        ProtectionLevelComponent,
        TravelUpgradesComponent,
        CarouselComponent,
        CarouselCarsComponent,
        LocationDetailComponent,
        CardLocationComponent,
        WarrantyComponent,
        TipsComponent,
        ReservationParentComponent,
        CancelReservationComponent,
        DeliveryStatusComponent,
        DeliveryCancelParentComponent,
        HrefSubheaderComponent,
        BillingDataComponent,
        PrecheckinProgressComponent,
        OfficialDocumentsComponent,
        ReservationInfoComponent,
        CarFeaturesComponent,
        RentalRequirementsComponent,
        PrimaryContainerComponent,
        EmptyContainerComponent,
        CardActiveReservationComponent,
        CardGeneralInformationComponent,
        CardFlightInformationComponent,
        PrecheckinLayoutComponent,
        PrecheckinButtonsComponent,
        AlertComponent,
        FeaturedPromotionsComponent,
        CardPromotionComponent,
        PromotionHeroComponent,
        PromotionOfferComponent,
        PromotionReasonsComponent,
        PromotionTermsComponent,
        FooterComponent,
        BlogCardsComponent,
        PopularDestinationsComponent,
        OfficeSearchComponent,
        ShowCityOfficeDetailsComponent,
        CardLandingTitleComponent,
        CarRentalPolicyComponent,
        HbsptformComponent,
        HbsptformNewComponent,
        HbsptformNewEnComponent,
        StartReservationComponent,
        ContainerCompanyPoliciesComponent,
        SearchReservationComponent,
        PickUpOptionsComponent,
        LocationDetailDestinationComponent,
        CarsCardsComponent,
        MaintenanceStandaloneComponent,
        CookieConsentComponent,
        UpgradePromotionComponent,
        UpgradePromotionSummaryComponent,
        UpgradeCategoryComponent,
        StandardCareComponent,
        ReservationBannerComponent,
        PayMethodModalComponent,
        InsuranceInfoModalComponent,
        VehicleListComponent,
        ReviewReserveComponent,
        FormEnterprisesComponent,
        BannerLandingTitleComponent,
        TypPageComponent,
        SnowEffectComponent,
    ],
    imports: [
        UiModule,
        CommonModule,
        NgbAccordionModule,
        NgbPaginationModule,
        ReactiveFormsModule,
        FormsModule,
        NgSelectModule,
        TranslateModule.forChild({
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: ApiMissingTranslationHandler,
                deps: [SsrService],
            },
            extend: true,
        }),
        PipesModule,
        RouterModule,
        DirectivesModule,
        NgxMaskPipe,
        LottieModule.forRoot({ player: playerFactory }),
        DetailsDataModule,
        SweetAlert2Module.forRoot(),
        CancelationDataModule,
        CarouselDataModule,
        NewsletterDataModule,
    ],
})
export class ComponentsModule {}
